import React from 'react'
import { Checkbox } from '@mui/material'
import { onSort } from '../../utils'
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";
const TableHeadings = ({ removeTr = false, TableHeadData, numberOfSelected, rowCount, onSelectAllClick, className, color, setController = () => { }, controller = {} }) => {
  return (
    <>
      <thead className='text-center tableheader '>
        <tr>
          {onSelectAllClick && (
            <th className='p-0'>
              <Checkbox
                className='py-0'
                size="small"
                color="primary"
                // indeterminate={numberOfSelected > 0 && numberOfSelected < rowCount}
                // checked={rowCount > 0 && numberOfSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{ 'aria-label': 'select all desserts' }}
              />
            </th>
          )}
          {TableHeadData?.map((item, index) => (
            <th key={index} className={className}
              onClick={() => {
                if (item?.id) {
                  onSort(item?.id, controller, setController)
                }
              }}>
              {item?.label} {item?.id && <span>{(item?.id === controller?.sortValue && controller?.sortOrder === -1) ? <IoMdArrowDropup size={20} /> : <IoMdArrowDropdown size={20} />} </span>}
            </th>
          ))}
        </tr>
        {
          !removeTr && <tr className='default_tr_gap' ></tr>
        }

      </thead>
    </>
  )
}

export default TableHeadings